const getters = {
    token: state => state.user.token,
    showName(state) {
        return `当前的最新count值为: ${state.plannerList}`
    },
    /**
     * 获取徽章总数
     * @param state
     * @param keys
     * @returns {number}
     */
    getBadge(state, keys) {
        let badge = state.badge
        let count = 0;
        let key = keys.split(',');
        for (let k in key) {
            count += badge[k] ? 0 : badge[k]
        }
        return count;
    }
}
export default getters
